import { IVo } from '@wizeoo/akm-compute-lib';
import { Baseline, ChronoCode, FreeData, PhysicalTemplate } from '@wizeoo/akm-message-lib';
import { cloneDeep } from 'lodash-es';
import { BASIC_ENTITY_TYPE } from '../../model/enums';

/** contrat d'interface minimal pour tous les objets */
export interface IAmUnique {
  uid: string; // UID  DE LA SOURCE pour synchro
  domain: string; // le domaine
  businessUnitCode: string; // la BU
}


/** génération d'un clone pour les exports */
export function cloneEM(vo: IVo, entityClass: number): any {
  let clone: any = cloneDeep(vo.source);
  switch(entityClass) {
    case BASIC_ENTITY_TYPE.FREEDATA:
      const realFreeData: FreeData = clone as FreeData;
      realFreeData.freeDataValues = null;
      clone = realFreeData;
      break;
    case BASIC_ENTITY_TYPE.CHRONOCODE:
      const realChronoCode: ChronoCode = clone as ChronoCode;
      realChronoCode.children = null;
      clone = realChronoCode;
      break; 
    case BASIC_ENTITY_TYPE.BASELINE:
      const realBaseline: Baseline = clone as Baseline;
      // realBaseline.mms = null;
      realBaseline.series = null;
      realBaseline.trios = null;
      realBaseline.values = null;
      clone = realBaseline;
      break;
    case BASIC_ENTITY_TYPE.PHYSICAL_TEMPLATE:
        const realPhy: PhysicalTemplate = clone as PhysicalTemplate;
        realPhy.widgets = null;
        clone = realPhy;
        break;
    case BASIC_ENTITY_TYPE.BUSINESS_UNIT:
    case BASIC_ENTITY_TYPE.LANGUAGE:
    case BASIC_ENTITY_TYPE.COUNTRY:
    case BASIC_ENTITY_TYPE.FREEDATAVALUE:
    default: 
    // console.log('cloneMe', entityClass, clone);
  }
  return clone;
}


